"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
exports.default = new Network_1.default('bifrost-test', [
    new Token_1.default('bfc', 'BFC', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} BFC', 'icon/bfc.svg'),
    new Token_1.default('eth', 'ETH', 'bifi', 1, '0xc83EEd1bf5464eD5383bc3342b918E08f6815950', '', false, true, false, [], '{} biETH', 'icon/eth.svg'),
    new Token_1.default('bnb', 'BNB', 'bifi', 2, '0xCd8bf79fA84D551f2465C0a646cABc295d43Be5C', '', false, true, false, [], '{} biBNB', 'icon/bnb.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 3, '0x28661511CDA7119B2185c647F23106a637CC074f', '', false, true, false, [], '{} biUSDC', 'icon/usdc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0x8010a873d59719e895E20f15f9906B5a1F399C3A', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'bfc'),
    new Handler_1.default(1, 'eth'),
    new Handler_1.default(2, 'bnb'),
    new Handler_1.default(3, 'usdc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('xBifi.maxBoost', 'getMaxBoost(uint256)', ['handlerID'], ['uint256']),
    new Method_1.default('xBifi.startPosition', 'getStartPosition(uint256,uint256,uint256,uint256,uint256,address,uint256)', [
        'srcHandlerID',
        'dstHandlerID',
        'collateralAmount',
        'times',
        'slippage',
        'user.address',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.positionNFTs', 'getAllPositionNFT(address)', ['user.address'], ['(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]']),
    new Method_1.default('xBifi.claim', 'getClaimableBifi(address)', ['address'], ['uint256']),
    new Method_1.default('xBifi.endPosition', 'getEndPosition(address,uint256,uint256)', [
        'address',
        'slippage',
        'bifiAmount'
    ], ['(uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)']),
    new Method_1.default('xBifi.oracle', 'getOracle()', [], [
        'uint256[]',
        'uint256[]',
        'uint256[]'
    ]),
    new Method_1.default('xBifi.amountsOfOut', 'getAmountsOut(uint,uint256[2])', [
        'amountIn',
        'tokenIDs'
    ], ['uint'])
], [
    new EntryPoint_1.default('bifi', '0x15f7B8F420dEE752e6D1D449d9051382BC8b7Da8'),
    new EntryPoint_1.default('xBifi', '0xeb6fD7bD7E156cF7Eed19952E86096706caa052c'),
    new EntryPoint_1.default('xBifi.factory', '0x5CEFb31E960F61b29D211F7Df6D78cF051CFD124')
], 3000);
//# sourceMappingURL=bifrost-test.js.map